import { StylesConfig } from 'react-select';
import { ListItem } from './types';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';

export function getReactSelectStyles(): StylesConfig<ListItem> {
  return {
    menu: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '0 0 5px 5px',
      transform: 'none',
      width: "auto",
      minWidth: '155px',
    }),
    menuList: (provided: any, state: any) => ({
      ...provided,
      maxHeight: 500,
      fontWeight: '1.8rem',
      display: 'flex',
      flexDirection: 'column'
    }),
    menuPortal: (provided: any, state: any) => ({
      ...provided,
      zIndex: 500,
    }),
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      textAlign: 'center',
      // padding: '2px 0'
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      background: '#333 !important',
      border: `1px solid #666 !important`,
      boxShadow: 'none', // for focus outline
      borderRadius: '0 !important',
      borderRight: 'none !important',
      borderLeft: 'none !important',
      cursor: 'pointer',
      minHeight: 35,
      height: '100%',
      '&:hover': {
        border: '1px solid #666 !important',
        borderRight: 'none !important',
        borderLeft: 'none !important',
        backgroundColor: '#434343 !important',
      },
      '&:active': {
        border: '1px solid #666 !important',
        borderRight: 'none !important',
        borderLeft: 'none !important',
        backgroundColor: '#616161 !important',
      }
    }),
    container: (provided: any, state: any) => ({
      ...provided,
      width: '100%',
      height: '100%',
      // padding: 0
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      background: 'transparent !important',
      padding: 0,
      '&:hover': {
        background: `${Colors.get(APP_COLORS.clrGreyLight)}!important`,
      }

    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      color: '#fff !important',
    }),
    indicatorSeparator: (provided: any, state: any) => ({
      ...provided,
      color: '#fff !important',
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      padding: '0 8px',
      color: `${Colors.get(APP_COLORS.clrNbiMagenta)} !important`,
    }),
    placeholder: (provided: any, state: any) => ({
      ...provided,
      color: '#fff !important',
      fontSize: '1.6rem',
    }),
  };
}
